import { Component, OnInit, OnDestroy } from '@angular/core';
import { IdleService } from './core/auth/idle.service';
import { AuthTokenService } from './core/auth/auth-token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private idleService: IdleService,
    private authTokenService: AuthTokenService
  ) {}

  title = 'Wabtec-frontend';

  ngOnInit(): void {
    // Start idle detection only if user is authenticated
    if (this.authTokenService.getAccessToken()) {
      this.idleService.startWatching();
    }
  }

  ngOnDestroy(): void {
    this.idleService.stopWatching();
  }
}
